/**
 * Postgres SQLSTATE and PostgREST error codes surfaced to the frontend.
 *
 * These literals were previously duplicated as magic strings across error
 * handlers (supabase-utils, view-visibility-errors, crm cell-edit, the draft
 * autosave queue, …). Reference these constants so the next handler that needs
 * one touches a single source of truth.
 *
 * Values are the wire codes — do not change them; they are defined by Postgres
 * (https://www.postgresql.org/docs/current/errcodes-appendix.html) and PostgREST.
 */

/** SQLSTATE 23505 — unique_violation (e.g. an `email_drafts_pkey` reuse). */
export const PG_UNIQUE_VIOLATION = '23505';

/** SQLSTATE 42501 — insufficient_privilege (RLS / grant denial). */
export const PG_INSUFFICIENT_PRIVILEGE = '42501';

/**
 * SQLSTATE P0004 — raised by the send-lifecycle guards when a send owns the
 * draft (claimed, in flight, or awaiting settlement). Clears once the send
 * settles, never by retrying the same write.
 */
export const PG_SEND_IN_PROGRESS = 'P0004';

/**
 * PostgREST PGRST116 — no rows returned where exactly one was expected (the
 * row is missing or RLS hid it). Does not clear on retry with the same request.
 */
export const PGRST_NO_ROWS = 'PGRST116';
